if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.rmDeliveryUpsell = document.querySelector('rm-delivery-upsell');
      this.rmSideLoadCart = document.querySelector('rm-sideload-cart');

      // Add safety check for product-upsell-product element
      try {
        const upsellElement = document.getElementById('product-upsell-product');
        this.upsellsData = upsellElement ? JSON.parse(upsellElement.textContent) : {};
      } catch (error) {
        this.upsellsData = {};
      }
    }

    async RmAddAddables() {
      let addables = [];
      const returnData = {
        "addables": [],
        "rmUpsellCartData": null,
        "rmUpsellCartDataNew": null
      };
      
      // Add safety check for localStorage.rmUpsellCartData
      let rmUpsellCartData;
      try {
        rmUpsellCartData = JSON.parse(localStorage.rmUpsellCartData || '{"products": [], "upsells": []}');
      } catch (error) {
        rmUpsellCartData = {"products": [], "upsells": []};
      }

      // Exclude frequently bought together checkboxes from default add to cart
      const addableCheckboxes = document.querySelectorAll('.rm-main-product-addable-item-checkbox:not(.rm-main-product-frequently-bought-item-checkbox)');
      const addableUpsell = document.querySelector('.rm-main-product-primary-upsell');

      if(addableCheckboxes == null) return;

      let existingProductIndex;
      let addableErrors = [];

      // get the current product/variant id
      const productIdInput = document.querySelector('input[name="id"]');
      if (!productIdInput) {
        return;
      }
      const productId = productIdInput.value;
      // get the current product quantity - add null check
      const qtyInput = document.querySelector('.quantity__input');
      const productForm = this;
      
      // Default quantity to 1 if no quantity input exists (for quick buy compatibility)
      const defaultQuantity = 1;
      
      if(addableUpsell != null) {
        // Add safety check for dataset.id
        if (!addableUpsell.dataset.id) {
          return;
        }
        
        // check if the product already exists in our data
        existingProductIndex = rmUpsellCartData.products.findIndex(product => { return product.id == productId });
        
        // create entry for product if it doesn't exist
        if(existingProductIndex === -1) {
          rmUpsellCartData.products.push({
            "id": productId,
            "upsellId": addableUpsell.dataset.id,
            "quantity": 0,
            "price": 0,
            "key": null
          })
          // refresh existing product index
          existingProductIndex = rmUpsellCartData.products.findIndex(product => { return product.id == productId });
        }
      } else {
      }

      for(let checkbox of addableCheckboxes) {
        
        if (checkbox.checked && checkbox.dataset.id != '') {
          // Add safety check for checkbox dataset.id
          if (!checkbox.dataset.id) {
            continue;
          }
          
          let quantity = 1;
          // we need to store some data to link in the cart
          if(checkbox.classList.contains('rm-main-product-primary-upsell')) {
            // get the quantity to add - use safe quantity access
            if (qtyInput && qtyInput.value) {
              quantity = parseInt(qtyInput.value);
            } else {
              quantity = defaultQuantity;
            }
            
            let addableItemVariant = await this.getVariantData(checkbox.dataset.id);
            
            // Simplified inventory check - only if variant data is available
            if (addableItemVariant && addableItemVariant.inventory_quantity && quantity > addableItemVariant.inventory_quantity) {
              addableErrors.push({
                "addable": addableItemVariant,
                "quantity": quantity
              });
              return;
            }
            // set/modify the data
            if(existingProductIndex !== -1) {
              rmUpsellCartData.products[existingProductIndex].quantity += quantity;
              let rmUpsellProductIndex = rmUpsellCartData.upsells.findIndex(product => { return product.id == checkbox.dataset.id });
              
              // Add safety check for rmUpsellProductIndex
              if (rmUpsellProductIndex === -1) {
                rmUpsellCartData.upsells.push({
                  id: checkbox.dataset.id,
                  quantity: quantity,
                  price: addableItemVariant ? addableItemVariant.price : 0
                });
                rmUpsellProductIndex = rmUpsellCartData.upsells.length - 1;
              } else {
                rmUpsellCartData.upsells[rmUpsellProductIndex].quantity += quantity;
              }
              
              // Add safety check for upsell price
              if (typeof rmUpsellCartData.upsells[rmUpsellProductIndex].price === 'undefined' || rmUpsellCartData.upsells[rmUpsellProductIndex].price === null) {
                rmUpsellCartData.upsells[rmUpsellProductIndex].price = addableItemVariant ? addableItemVariant.price : 0;
              }
              
              rmUpsellCartData.products[existingProductIndex].price = rmUpsellCartData.products[existingProductIndex].quantity * rmUpsellCartData.upsells[rmUpsellProductIndex].price;
            } else {
            }
          }
          addables.push({
            'id': checkbox.dataset.id,
            'quantity': quantity,
            'properties': {
              'parent_rug_id': productId
            }
          });
        }
      }

      if (addables.length < 1) return;

      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'items': addables
        })
      };

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config)
  
      if (!response.ok) {
        if(response.status != 422) {
          const message = `An error has occured when adding addables: ${response.status}`;
          throw new Error(message);
        } else {
          alert(`Maximum quantity for this addable has been reached`)
        }
      } else {
        // store upsell data for later
        localStorage.setItem('rmUpsellCartData', JSON.stringify(rmUpsellCartData));
      }
  
      return await response.json();
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      // RM The preorder app doesn't have the spinner in the button markup so we do a check
      const spinner = this.querySelector('.loading-overlay__spinner');

      if (spinner) {
        spinner.classList.remove('hidden');
      }

      // TODO Look into how to combine the requests.
      await this.RmAddAddables();

      // Remove automatic addition of frequently bought together items
      // The upsells now have their own separate "Add All to Cart" functionality
      // const frequentlyBoughtElement = document.querySelector('frequently-bought-together');
      // if (frequentlyBoughtElement && typeof frequentlyBoughtElement.addFrequentlyBoughtToCart === 'function') {
      //   try {
      //     await frequentlyBoughtElement.addFrequentlyBoughtToCart();
      //   } catch (error) {
      //     // Don't stop the main product from being added
      //   }
      // }

      let errors = false;
      

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            errors = true;
            return;
          }
          // modify upsell data to add the cart key 
          if(typeof localStorage.rmUpsellCartData != 'undefined') {
            let rmUpsellCartData = JSON.parse(localStorage.rmUpsellCartData)
            let existingProductIndex = rmUpsellCartData.products.findIndex(product => { return product.id == response.id });
            if(existingProductIndex > -1) {
              rmUpsellCartData.products[existingProductIndex].key = response.key;
              localStorage.setItem('rmUpsellCartData', JSON.stringify(rmUpsellCartData));
            }
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          // Error handling for cart update
        })
        .finally(async () => {
          if(!errors) {
            this.rmDeliveryUpsell.updateDisplay();
            if (this.rmSideLoadCart && typeof this.rmSideLoadCart.open === 'function') {
              this.rmSideLoadCart.open(true);
            }
          }
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    async getProductData(productId) {

      const response = await fetch(`/admin/products/${productId}.json`);

      if(!response.ok) {
        return false;
      }

      const data = await response.json();

      return data;
      
    }

    async getVariantData(variantId) {
      // Add safety check for productUrl dataset
      if (!this.dataset.productUrl) {
        return false;
      }

      const response = await fetch(`${this.dataset.productUrl}?view=data-available-json`);

      if(!response.ok) {
        return false;
      }

      let data = await response.json();

      return data.variants.find(variant => variant.id == variantId);
      
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

customElements.define('product-card-add', class ProductCardAdd extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.productId = this.getAttribute('data-product-id');
    this.productHandle = this.getAttribute('data-product-handle');
    this.variantId = this.getAttribute('data-variant-id');
    this.rmSideLoadCart = document.querySelector('rm-sideload-cart');
    this.addEventListener('click', this.addVariantToCart.bind(this));
  }

  async addVariantToCart(e) {
    e.preventDefault();
    const variantId = this.variantId;
    const productRequest = await fetch(`${window.Shopify.routes.root}products/${this.productHandle}.js`);
    const productData = await productRequest.json();
    const variant = productData.variants.find(variant => variant.id == variantId);
    this.querySelector('span').classList.add('hidden');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    const added = await this.rmSideLoadCart.addProduct(variantId, 1);
    if (added && this.rmSideLoadCart && typeof this.rmSideLoadCart.open === 'function') {
      this.rmSideLoadCart.open(true);
    }
    this.querySelector('span').classList.remove('hidden');
    this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    if(variant && typeof window.aa != 'undefined') {
      const eventData = {
        userToken: localStorage.getItem('aaUserTokenAnon'),
        eventName: 'added_to_cart',
        index: 'shopify_products',
        objectIDs: [variant.id],
        objectData: [
          {
            price: parseFloat(variant.price / 100),
            quantity: 1
          }
        ],
        value: parseFloat(variant.price / 100),
        currency: window.Shopify.currency.active
      };
      if(localStorage.getItem('aaUserTokenAuth') != null) {
        eventData['authenticatedUserToken'] = localStorage.getItem('aaUserTokenAuth');
      }
      
      // Get queryID from algolia_last_click if available
      const lastClickData = localStorage.getItem('algolia_last_click');
      let queryID = '';
      if (lastClickData) {
        try {
          const clickInfo = JSON.parse(lastClickData);
          queryID = clickInfo.queryID || '';
          } catch (e) {
          console.warn('Error parsing algolia_last_click:', e);
        }
      }
      
      // Add queryID if available
      if (queryID) {
        eventData.queryID = queryID;
      }
      
      // Check if slide-out cart is handling the event to prevent duplicates
      if (window.realmedia && window.realmedia.sideloadCartAdding) {
        
      } else {
        window.aa('addedToCartObjectIDs', eventData);
      }
      
      // Store purchase data for checkout script compatibility
      try {
        // Create purchase object for checkout script
        const purchaseObject = {
          index: 'shopify_products',
          objectIDs: [variant.id.toString()],
          eventName: 'Add To Cart',
          currency: window.Shopify.currency.active,
          timestamp: Date.now()
        };
        
        // Add queryID if available
        if (queryID) {
          purchaseObject.queryID = queryID;
        }
        
        // Store in purchase objects array
        const purchaseObjects = JSON.parse(localStorage.getItem('algolia_analytics_purchase_objects') || '[]');
        purchaseObjects.push(purchaseObject);
        
        // Keep only the last 20 purchase objects to prevent storage bloat
        const limitedPurchaseObjects = purchaseObjects.slice(-20);
        localStorage.setItem('algolia_analytics_purchase_objects', JSON.stringify(limitedPurchaseObjects));
        
        // Also store in sessionStorage for cross-domain access
        try {
          sessionStorage.setItem('algolia_analytics_purchase_objects', JSON.stringify(limitedPurchaseObjects));
        } catch (e) {
        }
        
        // Keep clicked objects for checkout script - DON'T remove them
        // The checkout script needs both clicked objects AND purchase objects
      } catch (error) {
      }
    }
  }
});